/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function o(){return/iPhone/gi.test(window.navigator.platform)||/Mac/gi.test(window.navigator.platform)&&window.navigator.maxTouchPoints>0}export{o as isIOS};
//# sourceMappingURL=platform.js.map
